export default {
  'inbox.delete.success': 'Item deleted successfully.',
  'inbox.field.description': 'Description',
  'inbox.field.title': 'Title',
  'inbox.field.contact': 'Contact',
  'inbox.field.message': 'Message',
  'inbox.title.create': 'Create item',
  'inbox.field.accepted_status': 'Accepted',
  'inbox.status.accepted': 'Accepted',
  'inbox.field.status': 'Status',
  'agent-inbox.field.from_email': 'From',
  'agent-inbox.field.from_name': 'From',
  'agent-inbox.field.subject': 'Subject',
  'agent-inbox.field.created_at': 'Created At',
  'agent-inbox.field.message': 'Message',
  'agent-inbox.field.type': 'Type',
  'agent-inbox.field.sub_type': 'Sub Type',
  'agent-inbox.field.folder': 'Folder',
  'agent-inbox.title.content': 'Content',
  'inbox.tab.email': 'Email',
  'inbox.email_content': 'Email content',
  'inbox.open_in_mailbox': 'Open in Mailbox',
  'inbox.preview_unavailable': 'Preview is not available for this file type.',
  'inbox.download_attachment': 'Download',
  'inbox.suggestions': 'Suggestions',
  'inbox.suggestion_prompt': 'What would you like to do with this email?',
  'inbox.view_markdown': 'View markdown',
  'inbox.markdown_preview': 'Markdown preview',
};
